(() => {
  'use strict';

  const ROOT = '.selleasy-block-product-addon';
  const CARD = '.lb-upsell-product-page-card';
  const TOGGLE = 'codex-selleasy-toggle';
  const COLLAPSED = 'codex-selleasy-card-collapsed';
  const VISIBLE_COUNT = 4;

  const addTransitionStyle = () => {
    if (document.getElementById('codex-selleasy-transition-style')) return;
    const style = document.createElement('style');
    style.id = 'codex-selleasy-transition-style';
    style.textContent = `${ROOT} ${CARD}{overflow:hidden;max-height:1000px;opacity:1;transition:max-height .28s ease,opacity .2s ease,margin .28s ease}${ROOT} .${COLLAPSED}{max-height:0!important;opacity:0;pointer-events:none;margin-top:0!important;margin-bottom:0!important}`;
    document.head.appendChild(style);
  };

  const getCards = (root) => [...root.querySelectorAll(CARD)];

  const update = (root) => {
    const cards = getCards(root);
    let toggle = root.querySelector(`.${TOGGLE}`);

    if (cards.length <= VISIBLE_COUNT) {
      if (toggle) toggle.remove();
      root.style.width = '';
      cards.forEach((card) => {
        card.hidden = false;
        card.classList.remove(COLLAPSED);
        card.style.width = '';
      });
      delete root.dataset.cardWidth;
      return;
    }

    if (!root.dataset.cardWidth && cards[0]) {
      root.dataset.cardWidth = `${cards[0].getBoundingClientRect().width}px`;
    }

    // Keep the app block at its original product-column width after cards are hidden.
    root.style.width = '100%';

    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = TOGGLE;
      toggle.style.cssText = 'display:block;width:100%;padding:8px 0;border:0;background:transparent;color:#f83a3a;font-weight: 500;cursor:pointer;font:inherit;text-align:right;';
      toggle.dataset.expanded = 'false';
      toggle.addEventListener('click', () => {
        const expanded = toggle.dataset.expanded === 'true';
        toggle.dataset.expanded = expanded ? 'false' : 'true';
        getCards(root).forEach((card, index) => {
          card.hidden = false;
          card.classList.toggle(COLLAPSED, !expanded && index >= VISIBLE_COUNT);
          card.style.width = !expanded ? root.dataset.cardWidth : '';
        });
        const remaining = Math.max(0, getCards(root).length - VISIBLE_COUNT);
        toggle.textContent = expanded ? `Show more (${remaining})` : 'Show less';
      });
      root.appendChild(toggle);
    }

    const expanded = toggle.dataset.expanded === 'true';
    cards.forEach((card, index) => {
      card.hidden = false;
      card.classList.toggle(COLLAPSED, !expanded && index >= VISIBLE_COUNT);
      card.style.width = !expanded ? root.dataset.cardWidth : '';
    });
    const remaining = Math.max(0, cards.length - VISIBLE_COUNT);
    toggle.textContent = expanded ? 'Show less' : `Show more (${remaining})`;
  };

  const mount = (root) => {
    let timer = 0;
    const schedule = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => update(root), 80);
    };

    update(root);
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true });
  };

  const start = () => {
    addTransitionStyle();
    const existing = document.querySelector(ROOT);
    if (existing) {
      mount(existing);
      return;
    }

    // Only watch for the async app mount. Disconnect immediately afterwards.
    const waitForApp = new MutationObserver(() => {
      const root = document.querySelector(ROOT);
      if (!root) return;
      waitForApp.disconnect();
      mount(root);
    });
    waitForApp.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
